export const PRINT_TEMPLATE = `
<!doctype html>
<html lang="hu">
<head>
  <meta charset="utf-8" />
  <title>{{TITLE}}</title>
  <style>
    @page { size: A4 landscape; margin: 0; }
    html, body { 
      width: 297mm; height: 210mm; margin: 0; padding: 0; 
      background: #fff; font-family: sans-serif; overflow: hidden;
    }
    
    /* A wrap most már kényszeríti a középre igazítást */
    .wrap { 
      width: 297mm; height: 210mm; padding: 10mm; 
      display: flex; flex-direction: column; 
      align-items: center; /* Vízszintes középre igazítás */
      box-sizing: border-box;
    }

    .header { width: 100%; flex: 0 0 auto; margin-bottom: 5mm; }
    .title { font-size: 24pt; font-weight: bold; margin: 0; text-align: left; }
    
    /* A fekete keret */
    #paper { 
      position: relative; 
      width: 100%; /* Kifeszül a paddingen belülre */
      flex: 1; 
      border: 2px solid #000; 
      background: #fff; 
      box-sizing: border-box;
      overflow: hidden;
    }
    
    .base { position: absolute; background: #f2f2f2; border: 1px solid #ccc; z-index: 1; }
    .wall { position: absolute; background: #333; z-index: 5; }
    .inactive { position: absolute; background: #eee; border: 1px dashed #999; z-index: 2; font-size: 7pt; display: flex; align-items: center; justify-content: center; text-align: center; }
    
    .bin { 
      position: absolute; background: rgba(255, 165, 0, 0.15); border: 1px solid #cc8400; 
      z-index: 10; display: flex; align-items: center; justify-content: center; 
      font-size: 8pt; font-weight: bold; text-align: center; color: #000;
    }
    .bin.rotate-text span { writing-mode: vertical-lr; transform: rotate(180deg); white-space: nowrap; }
  </style>
</head>
<body>
  <div class="wrap">
    <div class="header"><div class="title" id="title"></div></div>
    <div id="paper"></div>
  </div>

  <script>
    (function() {
      const data = {{MAP_JSON}};
      if (!data) return;

      document.getElementById("title").textContent = data.Name || "Raktár";
      const paper = document.getElementById("paper");
      
      // Tényleges pixelméretek lekérése
      const pW = paper.clientWidth;
      const pH = paper.clientHeight;

      const s = Math.min(pW / data.Dimensions.Width, pH / data.Dimensions.Height);
      const ox = (pW - data.Dimensions.Width * s) / 2;
      const oy = (pH - data.Dimensions.Height * s) / 2;

      function getDirFromVector(x, y) {
        if (Math.abs(x) > Math.abs(y)) return x > 0 ? 1 : 3;
        return y > 0 ? 2 : 0;
      }

      function draw(type, x, y, w, h, text) {
        const el = document.createElement("div");
        
        // Kiszámoljuk a pixelméreteket
        const pixelWidth = w * s;
        const pixelHeight = h * s;

        // Eldöntjük, kell-e forgatni: ha magasabb, mint amilyen széles, akkor forgatunk
        const isVertical = pixelHeight > pixelWidth;
        
        el.className = type + (isVertical ? " rotate-text" : "");
        el.style.left = (ox + x * s) + "px";
        el.style.top = (oy + y * s) + "px";
        el.style.width = pixelWidth + "px";
        el.style.height = pixelHeight + "px";
        
        if (text) {
          if (type !== 'bin' || data.showNames) {
            const span = document.createElement("span");
            
            let finalName = text;
            let fontSize = 8;
            const firstSlashIndex = text.indexOf('/');

            if (data.Id === 'ferto-fakkos-elo') {
              finalName = text;

              if(text.includes('FERTŐ-FAKKOS-ELŐTT-EGYÉB')){
                fontSize = 5;
              }
            } else if (data.Id === 'baratsag') {
              finalName = text;
            } else if (data.Id === 'polcoscsarnok' && text.includes('KAPU')) {
              const parts = text.split('/');
              finalName = parts.length >= 3 ? parts.slice(2).join('/') : (parts.length > 1 ? parts[1] : text);}
            else {
              finalName = firstSlashIndex !== -1 ? text.substring(firstSlashIndex + 1) : text;
            }
            
            el.style.fontSize = fontSize + "pt";
            span.textContent = finalName;
            el.appendChild(span);
          }
        }
        paper.appendChild(el);
      }

      // Alapok, Falak
      if (data.Elements) {
        (data.Elements.Bases || []).forEach(b => draw("base", b.X, b.Y, b.Width, b.Height, b.Name));
        (data.Elements.Walls || []).forEach(w => draw("wall", w.X, w.Y, w.Width, w.Height));
        (data.Elements.InactiveAreas || []).forEach(i => draw("inactive", i.X, i.Y, i.Width, i.Height, i.Name));
      }

      // Bins (Polcok)
      (data.Corridors || []).forEach(corridor => {
        const cDir = corridor.Direction || { X: 0, Y: 0 };
        (corridor.Blocks || []).forEach(block => {
          if (!block.Baseline || !block.FillDirection) return;
          const fX = block.FillDirection.X, fY = block.FillDirection.Y;
          const dir = getDirFromVector(-fX, -fY);
          const shouldRotate = (dir === 0 || dir === 2);

          (block.Bins || []).forEach(bin => {
            if (bin.Hidden) return;
            const bs = block.Baseline.Start;
            let x, y, w, h;
            if (dir === 3 || dir === 1) { // Vízszintes
              w = block.Length; h = bin.End - bin.Start;
              x = bs.X + (fX < 0 ? -block.Length : 0);
              y = bs.Y + cDir.Y * (cDir.Y === 1 ? bin.Start : bin.End);
            } else { // Függőleges
              w = bin.End - bin.Start; h = block.Length;
              x = bs.X + cDir.X * (cDir.X === 1 ? bin.Start : bin.End);
              y = bs.Y + (fY < 0 ? -block.Length : 0);
            }
            draw("bin", x, y, w, h, bin.Id, shouldRotate);
          });
        });
      });
    })();
  </script>
</body>
</html>
`;
